const FONT_LINKS = {
    'Arial': 'https://fonts.googleapis.com/css2?family=Arial&display=swap',
    'Comic Sans': 'https://fonts.googleapis.com/css2?family=Comic+Sans+MS&display=swap',
    'Courier New': 'https://fonts.googleapis.com/css2?family=Courier+New&display=swap',
    'Georgia': 'https://fonts.googleapis.com/css2?family=Georgia&display=swap',
    'Helvetica': 'https://fonts.googleapis.com/css2?family=Helvetica&display=swap',
    'Inter': 'https://fonts.googleapis.com/css2?family=Inter&display=swap',
    'Montserrat': 'https://fonts.googleapis.com/css2?family=Montserrat&display=swap',
    'Noto Sans': 'https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap',
    'Open Sans': 'https://fonts.googleapis.com/css2?family=Open+Sans&display=swap',
    'Roboto': 'https://fonts.googleapis.com/css2?family=Roboto&display=swap',
    'Tahoma': 'https://fonts.googleapis.com/css2?family=Tahoma&display=swap',
    'Times New Roman': 'https://fonts.googleapis.com/css2?family=Times+New+Roman&display=swap',
    'Trebuchet MS': 'https://fonts.googleapis.com/css2?family=Trebuchet+MS&display=swap',
    'Verdana': 'https://fonts.googleapis.com/css2?family=Verdana&display=swap',
    'Evolventa': 'https://fonts.cdnfonts.com/css/evolventa',
};

export const loadGoogleFont = (fontName) => {
    const trimmed = fontName?.trim();
    const fontUrl = FONT_LINKS[trimmed];

    if (!fontUrl) return;

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = fontUrl;
    document.head.appendChild(link);
};
